import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { error } from '@paypalcorp/pp-react';
import { useHistory } from 'react-router-dom';
import CountdownTimer from './CountdownTimer';
import BasicModal from '../componentsV3/modals/BasicModal';
import { fetcher } from '../../utility/domUtils';
import getLocaleMessages from '../utils/localesMessages';
import { ACTION, FPTI_SPEC } from '../utilsV3/fptiConstants';
import { trackEventWithData } from '../utilsV3/analytics';

const { dialogHeader, dialogMessage, continueButton } = getLocaleMessages(
  'buttonsV3/extendSession'
);

const ExtendSession = (props) => {
  const {
    confirmTime = 13 * 60 * 1000,
    expireTime = 15 * 60 * 1000,
    isLoggedIn = false,
  } = props;

  let sessionTimeout;

  const history = useHistory();

  const [isOpen, setIsOpen] = useState(false);
  const [isTimeout, setIsTimeout] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [extendSessionCalledAt, setExtendSessionCalledAt] = useState(
    new Date()
  );

  function logoutUserAndForceLogin() {
    const current_location = window.location.href;
    const returnUri = current_location.substr(
      current_location.indexOf('/buttons')
    );
    const renderURL = '/donate/buttons/login?returnUri=' + returnUri;
    fetcher('/donate/sessionlogout').finally(() => {
      history.push(renderURL);
      location.reload();
    });
  }

  useEffect(() => {
    // If the user is not logged in we should never show the modal
    if (!isLoggedIn) return;

    sessionTimeout = setTimeout(() => {
      if (!isOpen) {
        setIsOpen(true);
      }
    }, confirmTime);

    const fetchCallListener = () => {
      clearTimeout(sessionTimeout);

      sessionTimeout = setTimeout(() => {
        if (!isOpen) {
          setIsOpen(true);
        }
      }, confirmTime);
    };
    document.addEventListener('fetchCall', fetchCallListener);

    // Clear window events if the component is unmounted
    return () => {
      document.removeEventListener('fetchCall', fetchCallListener);
      clearTimeout(sessionTimeout);
    };
  }, []);

  useEffect(() => {
    if (isTimeout) {
      logoutUserAndForceLogin();
    }
  }, [isTimeout]);

  const requestExtendSession = async () => {
    // This function is called when the user click Extend Session and when the modal closes
    // Since the modal is closed after extending the session we need the logic below to prevent
    // duplicated extendSession call
    trackEventWithData(FPTI_SPEC.ALERT_MODAL_CONFIRM_CL, {
      action: ACTION.EXTEND_SESSION,
      step: props.currentStep,
      link: 'extend_session',
    });

    const now = new Date();
    const seconds = (now.getTime() - extendSessionCalledAt.getTime()) / 1000;
    if (seconds < 10) return;
    setExtendSessionCalledAt(new Date());

    setIsSending(true);
    await fetcher('/donate/api/extendSession')
      .then(() => {
        setIsOpen(false);
      })
      .catch(() => {
        logoutUserAndForceLogin();
      });
    setIsSending(false);
  };

  const fptiSpec = {
    impression: FPTI_SPEC.ALERT_MODAL_IM,
    data: {
      action: ACTION.EXTEND_SESSION,
      step: props.currentStep,
    },
  };

  return (
    <BasicModal
      className="modal-overlay hide-modal-header"
      id="extend-session-dialog"
      buttonLabel={continueButton}
      buttonState={isSending ? 'processing' : 'initial'}
      buttonOnClick={requestExtendSession}
      closeOnBackgroundClick={false}
      header={dialogHeader}
      iconType="warning"
      isOpen={isOpen}
      message1={dialogMessage}
      onClose={requestExtendSession}
      fptiSpec={fptiSpec}
    >
      <CountdownTimer
        milliseconds={expireTime - confirmTime}
        pause={isSending}
        onTimeout={setIsTimeout}
        styles={{ color: error }}
      />
    </BasicModal>
  );
};

ExtendSession.propTypes = {
  isLoggedIn: PropTypes.bool,
  confirmTime: PropTypes.number,
  expireTime: PropTypes.number,
  currentStep: PropTypes.number,
};

export default ExtendSession;
